<!--
 * @Date: 2021-01-28 01:27:29
 * @LastEditTime: 2022-02-09 13:08:20
 * @Description: 
 * @FilePath: /hsylc2021/src/components/form/FilterSelect/index.vue
-->
<template>
  <div class="component-filterSelect" :class="computedClass">
    <div class="input-render">
      <label class="component-label">{{ label }}</label>
      <div class="triangle-down z2" :class="focused ? 'up' : ''"></div>

      <el-select
        v-model="selectInput"
        class="component-filter-select w-normal"
        placeholder="请选择或输入学校全名"
        filterable
        :filter-method="filterFun"
        @blur="handleSelectBlur"
        @change="onSelectChange"
        @visible-change="visibleChagneHandler($event)"
      >
        <el-option
          class="w-normal"
          :class="getOptionClass(item)"
          v-for="(item, index) in options"
          :key="'option_' + index"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div v-if="(startVerific && error) || error" class="errmsg">{{ errmsg }}</div>
  </div>
</template>
<script>
/**
 * 一个简单的Vue插件
 * @module checkbox
 */
export default {
  name: '',
  props: {
    label: {
      type: String,
      default: '标签'
    },
    options: {
      type: Array,
      default: () => {
        return [
          {
            value: '选项1',
            label: 'aaa'
          },
          {
            value: '选项2',
            label: 'bbb'
          },
          {
            value: '选项3',
            label: 'ccc'
          },
          {
            value: '选项4',
            label: 'ddd'
          },
          {
            value: '选项5',
            label: 'eee'
          }
        ];
      }
    },
    className: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },

    isFocus: {
      type: Boolean,
      default: false
    },
    isHover: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    startVerific: {
      type: Boolean,
      default: true
    },
    value: {
      default: ''
    },
    errmsg: {
      type: String,
      default: '请选择'
    }
  },
  components: {},
  data() {
    return {
      focused: false,
      hover: false,
      searchKey: '',
      selectVisible: false,
      selectInput: '',
      selectOptions: [], // 筛选
      error: false // 选择框报错状态
    };
  },
  computed: {
    computedClass() {
      let ret = {};
      ret[`size-${this.size}`] = true;
      ret[this.className] = true;
      ret['disabled'] = this.disabled;
      ret['hover'] = this.hover;
      ret['active'] = this.isActive;
      ret['done'] = this.isDone;
      ret['error'] = this.error;
      return ret;
    },
    isActive() {
      let ret = false;
      if (this.focused) {
        ret = true;
      }
      return ret;
    },
    isDone() {
      let ret = false;
      if (this.value && this.value !== '') {
        ret = true;
      }
      return ret;
    }
  },
  watch: {
    options(val) {
      this.selectOptions = val;
      if (this.startVerific) {
        this.error = this.value === '' ? true : false;
      }
    },
    value() {
      if (this.value) this.selectInput = this.value;
    },
    isFocus() {
      this.focused = this.isFocus;
    },
    isHover() {
      this.hover = this.isHover;
    }
  },
  mounted() {
    if (this.value) this.selectInput = this.value;

    if (this.startVerific) {
      this.error = this.value === '' ? true : false;
    }
  },
  methods: {
    // 学校筛选框 筛选规则
    filterFun(val) {
      // console.log('筛选:', val);
      this.searchKey = val;
    },
    getOptionClass: function(option) {
      let isHidden = true,
        ret = {};
      let label = option.label,
        alias = option.aliases;
      if (this.searchKey && this.searchKey !== '') {
        if (label.toUpperCase().indexOf(this.searchKey.toUpperCase()) > -1) {
          isHidden = false;
        }
        if (alias && alias.length && alias.toUpperCase().indexOf(this.searchKey.toUpperCase()) > -1) {
          isHidden = false;
        }
      } else {
        isHidden = false;
      }
      if (isHidden) {
        // console.log(option);
        ret['hidden'] = true;
      }
      return ret;
    },
    /**
     * @description 鼠标覆盖输入框
     * @function handleInputMouseOver
     * @param {Object} e 事件对象
     */
    handleInputMouseOver: function() {
      this.hover = true;
      // this.mouseOver(e);
    },
    /**
     * @description 鼠标移出输入框
     * @function handleInputMouseOut
     * @param {Object} e 事件对象
     */
    handleInputMouseOut: function() {
      this.hover = false;
      // this.mouseOut(e);
    },
    handleSelectBlur() {
      // this.focused = false;
      this.checkSelectInput();
    },
    /**
     * @description 选项修改
     * @function onSelectChange
     * @param {String} val 数据
     */
    onSelectChange(val) {
      let label = this.valueToLabel(val);
      this.checkSelectInput();

      this.$emit('input', val);
      this.$emit('change', label);
    },
    // 下拉框 显示/ 隐藏状态监听
    /**
     * @description 下拉框 显示/ 隐藏状态监听
     * @function visibleChagneHandler
     * @param {String} val 数据
     */
    visibleChagneHandler(isShowOptions) {
      this.focused = isShowOptions;
      // this.selectVisible = isShowOptions;

      this.$emit('click');
    },
    // 检验 选项框 是否为空 否则报错
    checkSelectInput() {
      this.error = this.selectInput === '' ? true : false;
      // console.log('选择学校：', this.error, this.selectInput);
      this.$emit('blur', this.error, this.id, this.errmsg);
    },
    /**
     * @description options 通过value 查找label
     * @function valueToLabel
     * @param {String} val
     * @return {String}
     */
    valueToLabel(val) {
      let label = '';
      const that = this;
      for (let i = 0; i < that.options.length; i++) {
        const item = that.options[i];
        if (item.value === val) {
          label = item.label;
          return label;
        }
      }
    }
  }
};
</script>
<style lang="less" src="./select.less" scoped></style>
<style lang="less" scoped>
.el-select-dropdown__item.hidden {
  display: none;
}
</style>
